import PersonalBookingPageOptionViewState from './schema/PersonalBookingPageOptionViewState';
import { createStore } from 'satcheljs';
import '../actions/initializeSettingsMutator';
import '../mutators/setIsSavingMutator';
import '../mutators/updatePublishingSettingsMutator';
import '../mutators/setIsPerformingServiceUpdateMutator';
import '../mutators/setGetServicesStateMutator';
import '../mutators/loadServicesMutator';
import '../mutators/createServiceMutator';
import '../mutators/deleteServiceMutator';
import '../mutators/enableDisableServiceMutator';
import ServicesRequestStatus from './schema/ServicesRequestStatus';

let initialStore: PersonalBookingPageOptionViewState = {
    publishingSettings: null,
    services: undefined,
    servicesOrder: undefined,
    isSaving: false,
    isPerformingServiceUpdate: false,
    getServicesRequestStatus: ServicesRequestStatus.NotInitiated,
};

export default createStore<PersonalBookingPageOptionViewState>(
    'personalBookingPageOptionStore',
    initialStore
);
